module.exports = __webpack_public_path__ + "static/media/thankphone.7bddf622.png";